import {
  transformFlexibleBenefitsBenefitSummary,
  transformFlexibleBenefitsPayrollSummary,
  transformFlexibleBenefitsRollover,
  transformFlexibleBenefitsSummary,
} from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.dto';
import {
  TFlexibleBenefitsPayrollSummary,
  TFlexibleBenefitsRolloverSummary,
  TGetFlexibleBenefitsPayrollSummaryFilters,
  TMenhirFlexibleBenefitRollover,
  TMenhirFlexibleBenefitsBenefitSummary,
  TMenhirFlexibleBenefitsSummary,
} from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';
import { IMenhirBenefitSlug } from '../benefits/benefits.types';

export const getFlexibleBenefitsSummary = () =>
  menhirClient
    .get<
      null,
      { summary: TMenhirFlexibleBenefitsSummary }
    >(MENHIR_ENDPOINTS.EMPLOYEE.FLEXIBLE_BENEFITS.SUMMARY)
    .then(({ summary }) => transformFlexibleBenefitsSummary(summary));

export const getFlexibleBenefitsPayrollSummary = (
  filters?: TGetFlexibleBenefitsPayrollSummaryFilters
) =>
  menhirClient
    .get<null, { summary: TFlexibleBenefitsPayrollSummary }>(
      MENHIR_ENDPOINTS.EMPLOYEE.FLEXIBLE_BENEFITS.PAYROLL.SUMMARY,
      {
        params: {
          'filters[period_id]': filters?.periodId,
        },
      }
    )
    .then(({ summary }) => transformFlexibleBenefitsPayrollSummary(summary));

export const getFlexibleBenefitsBenefitSummary = (slug: IMenhirBenefitSlug) =>
  menhirClient
    .get<
      null,
      { summary: TMenhirFlexibleBenefitsBenefitSummary }
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.FLEXIBLE_BENEFITS.BENEFITS.SUMMARY, slug))
    .then(({ summary }) => transformFlexibleBenefitsBenefitSummary(summary));

export const getFlexibleBenefitsRollover = (slug: IMenhirBenefitSlug) =>
  menhirClient
    .get<
      null,
      { rollover: TMenhirFlexibleBenefitRollover }
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.FLEXIBLE_BENEFITS.BENEFITS.ROLLOVER, slug))
    .then(({ rollover }) => transformFlexibleBenefitsRollover(rollover));

export const updateFlexibleBenefitsRollover = (
  slug: IMenhirBenefitSlug,
  active: boolean
) =>
  menhirClient.patch<null>(
    endpointFor(
      MENHIR_ENDPOINTS.EMPLOYEE.FLEXIBLE_BENEFITS.BENEFITS.ROLLOVER,
      slug
    ),
    {
      rollover: {
        active,
      },
    }
  );

export const getFlexibleBenefitsRolloverSummary = () =>
  menhirClient
    .get<
      null,
      { rollover: TFlexibleBenefitsRolloverSummary }
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.FLEXIBLE_BENEFITS.ROLLOVER))
    .then(({ rollover }) => rollover);
